export enum AudienceRuleModes {
  Geofence = 'GEOFENCE',
  Demographic = 'DEMO',
  Segments = 'SEGMENT',
  SegmentMarketplace = 'SEGMENT_MARKETPLACE',
  PredefinedDemographic = 'PREDEFINED_DEMOGRAPHIC',
  Epsilon = 'EPSILON',
  MastercardGeofence = 'MASTERCARD_GEOFENCE',
}

// We have to keep this for backwards compatibility
const EXTERNAL_SEGMENT_MODES = [AudienceRuleModes.Epsilon, AudienceRuleModes.Segments];
export function isExternalSegmentRule(mode: AudienceRuleModes) {
  return EXTERNAL_SEGMENT_MODES.includes(mode);
}
